import { t } from "@lingui/macro";
import React from "react";

import { Crementor } from "@whoosh/design-system/src/components/controls/Crementor";
import { Avatar } from "@whoosh/design-system/src/components/display";
import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

type MemberHoldCounterSmallProps = {
  memberHoldEnabled?: boolean;
  checkNewDisabled?: boolean;
  isDecrementDisabled?: boolean;
  isIncrementDisabled?: boolean;
  memberHoldLimit?: number;
  memberHoldCount: number;
  hasReachedAttendeesLimit: boolean;
  onAddMemberHold?: () => void;
  onRemoveMemberHold?: () => void;
};

const MemberHoldCounterSmall = ({
  memberHoldEnabled,
  checkNewDisabled,
  isDecrementDisabled,
  isIncrementDisabled,
  memberHoldLimit,
  memberHoldCount,
  hasReachedAttendeesLimit,
  onAddMemberHold,
  onRemoveMemberHold,
}: MemberHoldCounterSmallProps) => {
  return memberHoldEnabled ? (
    <HStack
      pt={10}
      pb={5}
      mx={6}
      justifyContent="space-between"
      alignItems="center"
      opacity={!memberHoldCount && checkNewDisabled ? 0.5 : 1}
    >
      <HStack alignItems="center">
        <Avatar type="member" size="sm" />
        <Text marginLeft={4}>{t`Member Hold`}</Text>
      </HStack>
      <Crementor
        min={0}
        max={hasReachedAttendeesLimit ? 0 : memberHoldLimit}
        value={memberHoldCount}
        onIncrement={onAddMemberHold}
        onDecrement={onRemoveMemberHold}
        isDecrementDisabled={isDecrementDisabled}
        isIncrementDisabled={isIncrementDisabled}
      />
    </HStack>
  ) : null;
};

export default MemberHoldCounterSmall;
